import { useLayoutEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "motion/react"; // use "framer-motion", not "motion/react"

const AnimatedBottomSentence = ({ sentence, index, top = false }) => {
    const containerRef = useRef(null);
    const hiddenTextRef = useRef(null);

    const [scrollConfig, setScrollConfig] = useState({
        shouldScroll: false,
        scrollX: 0,
    });
    const [ready, setReady] = useState(false);
    const [renderKey, setRenderKey] = useState(0);

    useLayoutEffect(() => {
        setReady(false); // prevent flicker
        const measure = () => {
            if (containerRef.current && hiddenTextRef.current) {
                const containerWidth = containerRef.current.offsetWidth;
                const textWidth = hiddenTextRef.current.scrollWidth;

                const overflowAmount = textWidth - containerWidth;
                setScrollConfig({
                    shouldScroll: overflowAmount > 0,
                    scrollX: overflowAmount > 0 ? -overflowAmount : 0,
                });

                // Force re-render after measuring
                setRenderKey((prev) => prev + 1);
                setReady(true);
            }
        };

        requestAnimationFrame(measure);
    }, [sentence]);

    return (
        <div
            key={index}
            ref={containerRef}
            className={`${!top && "mt-3"} text-white overflow-hidden whitespace-nowrap relative`}
            style={top ? { height: "15px" } : { height: "22px" }}
        >
            {/* Hidden measuring text */}
            <div
                ref={hiddenTextRef}
                className="invisible absolute whitespace-nowrap"
                style={{ pointerEvents: "none" }}
            >
                {sentence}
            </div>

            <AnimatePresence mode="wait">
                {ready && (
                    <motion.div
                        key={renderKey}
                        initial={{
                            x: scrollConfig.shouldScroll ? 20 : 0,
                            opacity: 0,
                        }}
                        animate={{
                            x: scrollConfig.shouldScroll ? scrollConfig.scrollX : 0,
                            opacity: 1,
                        }}
                        exit={{ opacity: 0 }}
                        transition={{
                            x: {
                                delay: scrollConfig.shouldScroll ? 2 : 0,
                                duration: 1.8,
                                ease: "easeInOut",
                            },
                            opacity: { duration: 0.3 },
                        }}
                        className={`absolute w-full ${scrollConfig.shouldScroll ? "left-0" : "text-center"}`}
                    >
                        {sentence}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default AnimatedBottomSentence;
